import { createAction, props } from "@ngrx/store";

export const FETCH_COUNTRY_MASTER_LIST = createAction(
    'FETCHCOUNTRYMASTERLIST',
    props<{ countries: any }>()
);

export const FETCH_COUNTRY_MASTER = createAction(
    'FETCHCOUNTRYMASTER',
    props<{ country: any }>()
);